export default __webpack_public_path__ + "static/masthead-vid-be274173b3ac05b42bc65c85e9b1d71f.mp4";